__turbopack_context__.v({
  "DropdownItem": "DropdownItem-module__YJ1ShG__DropdownItem",
  "DropdownItemDestructive": "DropdownItem-module__YJ1ShG__DropdownItemDestructive",
});
